import axios from 'axios'

export const fetchApiData = (apiUrl: string) => axios.get(apiUrl)

export const postApiData = (apiUrl: string, body: any) => axios.post(apiUrl, body)
